import React,{useState, useEffect, useRef} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { userurl } from "../../apis/urls";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";


const ResetAssociationPassword = () => {

    const userid = localStorage.getItem('userid');

    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');

    const {id, sid} = useParams()

    console.log('idm', id)
    const navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/members/"+sid)
    }

    const [passwordError,setPasswordError] = useState(false);
    const [confirmPasswordError,setConfirmPasswordError] = useState(false);
    const [sameError,setSameError] = useState(false);
    const [passvalid, setPassValid] = useState(false)

    let onChangePassword = () =>{

        let error = 0;

		if(password === '')
		{
			setPasswordError(true)
			error =1;
		}
		else
		{
			setPasswordError(false)
		}

        if(confirmPassword === '')
		{
			setConfirmPasswordError(true)
			error =1;
		}
		else
		{
			setConfirmPasswordError(false)
		}
        if (password !== confirmPassword) {
            setSameError(true);
            error = 1;
        } else {
            setSameError(false);
        }

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!passwordRegex.test(password)) {
            setPassValid(true); // Password doesn't meet complexity requirements
            error = 1;
        } else {
            setPassValid(false);
        }



        if(error === 0)
        {
            let token = "Bearer "+localStorage.getItem('token');

            const data = {
                userid:id,
                password:password,
                confirmPassword:confirmPassword
            }

            const instance = axios.create({

                baseURL: userurl+"/permissionresetpassword",

                timeout: 1000000,

                headers: {'authorization': token}

            });

            instance.put('',data).then((response) =>{

                alert("password changed succesfully.")
                navigate("/associations")

            }).catch((error) =>{
                console.log('error',error.response.data.error[0].confirmPassword)

                if(error.response.data.error[0].confirmPassword === 'Confirm password doesnot match')
                {
                    setSameError(true)

                }

                if(error.response.data.error){
                    setPassValid(true)
                }else{
                    setPassValid(false)
                }
               

            });;

        }
    }
   

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Reset Password</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>


                    <form className="needs-validation">
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >New Password<span style={{color: "red"}}>*</span></label>
                                            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="form-control justshow bg-dark" placeholder="Enter Password" />
                                            {
                                                passwordError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter the password.</div>:null
                                            }
                                        </div>
                                       
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Confirm Password<span style={{color: "red"}}>*</span></label>
                                            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="form-control justshow bg-dark" placeholder="Enter Confirm Password" />
                                            {
                                                confirmPasswordError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter the confirm password.</div>:null
                                            }
                                            {
                                                sameError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Confirm password doesnot match.</div>:null
                                            }
                                            {
                                                passvalid
                                                ? <div className="nerrors" style={{color:"red",fontSize: "10px"}}>Password should be combination of one uppercase , one lower case, one special char, one digit and min 8 char long</div>:null
                                            }
                                        </div>

                                       
                                    </div>

                                </div>

                                <div className="form-group">
                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                    <button onClick={ onChangePassword } className="btn btn-primary btn-gisa" type="button">Change Password </button>
                                </div>



                                </div>
                            </div>
                        </div>
                    </form>



                </div>
            </aside>
        </div>
    )
}

export default ResetAssociationPassword;